import { Content, ProjectDetailsContainer } from './styles';
import DynamicZones from '../DynamicZones';
import { ProjectProjectsDynamicDynamicZone, Technology, Testimony } from '../../../types/schema';
import Typography from '../../ui/Typography';
import { useRouter } from 'next/router';

export type ProjectPageTemplateProps = {
  projectsDynamic: ProjectProjectsDynamicDynamicZone[];
  technologies?: Technology[];
  testimonies?: Testimony[];
  image: string;
  title: string;
};

const ProjectPageTemplate: React.FC<ProjectPageTemplateProps> = ({
  projectsDynamic,
  image,
  title,
  technologies,
  testimonies,
}) => {
  const router = useRouter();
  const language = router.locale;
  return (
    <Content>
      <div className="image">
        <img srcSet={image} alt={title} />
      </div>
      <ProjectDetailsContainer>
        <Typography marginLeft="-1px" variant="h1">
          {title}
        </Typography>
      </ProjectDetailsContainer>
      <DynamicZones
        contentStyle={{ paddingTop: 0, paddingBottom: 10 }}
        dynamicZones={projectsDynamic}
        allTechnologies={technologies}
        allTestimonies={testimonies}
        language={language}
        techsInsideContainer
      />
    </Content>
  );
};

export default ProjectPageTemplate;
